import { SupportedLocale, supportedLocales } from './types';

/*
The below function takes the app's current language and extracts from it the full language code to pass (among others) to the Adyen section of Cleeng components.
N.B.: Hebrew is not supported by Adyen. If there will be more app languages supported in the future, expand the SupportedLocale type and map
 */
export const getLocaleFromLanguageCode = (
    languageCode: string | null | undefined
): SupportedLocale => supportedLocales[languageCode ?? 'en'] ?? 'en-US';
